import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { FindingsPage } from '@/features/findings/list/findings-page';
import { parseFindingSearch } from '@/features/findings/list/finding-search';

export const Route = createFileRoute('/_app/w/$workspaceId/findings/')({
    staticData: { crumbs: [{ label: 'shell.findings' }] },
    validateSearch: parseFindingSearch,
    loaderDeps: ({ search }) => ({ search }),
    loader: ({ context, deps }) => prefetch.findings(context.queryClient, context.workspaceScope, deps.search),
    component: function FindingsRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        const search = Route.useSearch();
        return <FindingsPage organizationId={organizationId} workspaceId={workspaceId} search={search} />;
    },
});
